"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ghilarza": {
    "d67349c4": [{
      "hkey": "e771a86f",
      "slug": "ghilarza",
      "name": "Ghilarza",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "e771a86f",
      "slug": "ghilarza",
      "name": "Ghilarza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "78a1adf5": [{
      "hkey": "e771a86f",
      "slug": "ghilarza",
      "name": "Ghilarza",
      "primary": true,
      "skipSearch": false
    }],
    "san-serafino": [{
      "hkey": "e771a86f",
      "slug": "ghilarza",
      "name": "Ghilarza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "54558a87": [{
      "hkey": "e771a86f",
      "slug": "ghilarza",
      "name": "Ghilarza",
      "primary": true,
      "skipSearch": false
    }],
    "trempu": [{
      "hkey": "e771a86f",
      "slug": "ghilarza",
      "name": "Ghilarza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;